import { RESERVED_ERROR_CODES } from "@cervval.js/common/src/errors/errors";

// error codes from 540 to 549 are reserved for permissions errors
export enum PermissionErrorCodes {
    RESERVED = RESERVED_ERROR_CODES, // * You can check all reserved codes here

    MISSING_PERMISSIONS = 590,
    OBJECT_NOT_FOUND = 591,
    NO_REQUEST_PARAMETERS = 592,
    FAILED_TO_BUILD_CONTEXT = 593
}